<template>
    <div>
        <sweet-modal blocking title="Journal Entry Info" ref="journalEntryInfoModal" class="modal" v-on:close="closeJournalEntryInfo">
            <el-form :model="form" size="mini" ref="form" status-icon  class="demo-ruleForm">
                <el-row :span="24" :gutter="20">
                    <el-col :span="6">
                        <el-form-item label-width="115px" label="Journal Date" prop="journalDate">
                            {{moment(form.journalDate).format('DD MMM YYYY')}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label-width="115px" label="Document Date" prop="documentDate">
                            {{moment(form.documentDate).format('DD MMM YYYY')}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label-width="115px" label="Reference" prop="reference">
                            {{form.reference}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label-width="115px" label="Currency" prop="currencyId">
                            {{form.currency.name}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label-width="115px" label="Event Date" prop="eventDate">
                            {{moment(form.eventDate).format('DD MMM YYYY')}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label-width="115px" label="Source ref" prop="sourceRef">
                            {{form.sourceRef}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :span="24">
                    <el-form-item label-width="115px" label="Description" prop="description">
                        {{form.description}}
                    </el-form-item>
                </el-row>
                <el-table
                        size="mini"
                        border
                        :data="form.items"
                        style="width: 100%">
                    <el-table-column
                            label="Account Code"
                            width="120">
                        <template slot-scope="scope">
                            {{scope.row.code}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Name">
                        <template slot-scope="scope">
                            {{scope.row.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Debit"
                            width="150">
                        <template slot-scope="scope">
                            <div style="text-align:right;">
                            {{formatPrice(scope.row.debit)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Credit"
                            width="150">
                        <template slot-scope="scope">
                            <div style="text-align:right;">
                                {{formatPrice(scope.row.credit)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Description">
                        <template slot-scope="scope">
                            {{scope.row.description}}
                        </template>
                    </el-table-column>
                </el-table>
                <el-table size="mini"
                          border
                          :show-header="false"
                          :data="[form.totals]"
                          style="width: 100%">
                    <el-table-column
                            width="120">
                    </el-table-column>
                    <el-table-column>
                        <div style="text-align:right;">
                            Total
                        </div>
                    </el-table-column>
                    <el-table-column
                            width="150">
                        <template slot-scope="scope">
                            <div style="text-align:right;">
                                {{formatPrice(scope.row.debit)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="150">
                        <template slot-scope="scope">
                            <div style="text-align:right;">
                                {{formatPrice(scope.row.credit)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column>
                    </el-table-column>
                </el-table>
            </el-form>
        </sweet-modal>
    </div>
</template>

<script>
  import axios from 'axios'
  import { Money } from 'v-money'
  let moment = require('moment');
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

  export default {
    name: "journalEntryInfoModal",
    components:{
      SweetModal,
      Money
    },
    props: ['selectedRow'],
    data() {
      return{
        activeJournalEntryId: '',
        money: {
          precision: 2,
          decimal: ',',
          thousands: '.'
        },
        moment:moment,
        form:{
          journalDate: null,
          documentDate: null,
          reference: null,
          currency: {},
          eventDate: null,
          sourceRef: null,
          includeTaxRegister: false,
          description: '',
          glAccounts:null,
          totals: {
            debit: 0,
            credit: 0,
          },
          items: []
        }
      }
    },
    watch:{

    },
    computed:{

    },
    methods:{
      async openModalInfo(row){
        this.activeJournalEntryId = row.id;
        await this.getItem(row.id);
        await this.$refs.journalEntryInfoModal.open()
      },
      async getItem(id){
        return new Promise((resolve, reject) => {
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .get(`/api/v1/journalEntry/item?id=${id}`)
              .then(response => {
                this.form.journalDate = response.data.item.journalDate;
                this.form.documentDate = response.data.item.documentDate;
                this.form.reference = response.data.item.reference;
                this.form.currency = response.data.item.currency;
                this.form.eventDate = response.data.item.eventDate;
                this.form.sourceRef = response.data.item.sourceRef;
                this.form.includeTaxRegister = response.data.item.includeTaxRegistration;
                this.form.description = response.data.item.description;
                this.form.totals.debit = response.data.item.totalDebit;
                this.form.totals.credit = response.data.item.totalCredit;
                this.form.items = response.data.item.headers;
                resolve(response.data)
              }).catch(err => {
                reject(err)
              })
          }catch (err){
            console.log(err)
          }
        });
      },
      closeJournalEntryInfo(){
        this.$refs['form'].resetFields();
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
    }
  }
</script>

<style lang="less" scoped>
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width:100%;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
        .sweet-modal {
            max-width: 100% !important;
        }
    }
    /deep/.p-o{
        &:hover{
            cursor:pointer;
        }
    }
    .bill{
        text-align:right;
        h4{
            line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
</style>
